module.exports = __webpack_public_path__ + "static/twitter-757318353436942155bad06f9c3b75d5.png";